var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserPlus = function SvgUserPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.75a.75.75 0 0 1-.75.75h-1.5V15a.75.75 0 1 1-1.5 0v-1.5h-1.5a.75.75 0 1 1 0-1.5h1.5v-1.5a.75.75 0 1 1 1.5 0V12h1.5a.75.75 0 0 1 .75.75m-5.425 5.517a.75.75 0 0 1-1.15.966c-1.886-2.246-4.48-3.483-7.3-3.483s-5.414 1.237-7.3 3.483a.75.75 0 1 1-1.149-.966c1.4-1.667 3.143-2.85 5.079-3.484a6.375 6.375 0 1 1 6.74 0c1.936.633 3.678 1.817 5.08 3.484m-8.45-4.017a4.875 4.875 0 1 0 0-9.75 4.875 4.875 0 0 0 0 9.75"
  })));
};
export default SvgUserPlus;